import { oc } from '@orpc/contract';
import { updateUserInputSchema, userSchema } from '../schemas/users.schemas.js';
export const updateUserContract = oc
    .route({
    method: 'PATCH',
    path: '/users/{id}',
    tags: ['Users'],
    summary: 'Update name, email, role, status or pillar grants; guards the last active Administrator and self-lockout (ADMIN)',
})
    .input(updateUserInputSchema)
    .output(userSchema);
//# sourceMappingURL=update-user.contract.js.map